const ConditionsENGEnum = {
    TEN_DAY_PAYMENT_DELAY: '10-day postponement',
    FIFTEEN_DAY_PAYMENT_DELAY: '15-day postponement'
  };

export default ConditionsENGEnum;